import { useMemo } from 'react';
import { getDateShortcuts, subtractDaysFromDate, toIsoDate } from '@app/utils/date';
import { useSelector } from 'react-redux';
import { selectLastUploadedReportAt } from '@app/redux/features/userSlice';

function useCustomDateShortcuts(): [any, string | null, string | null] {
  const reportLastSyncDate = useSelector(selectLastUploadedReportAt);

  const shortcuts = useMemo(() => {
    if (!reportLastSyncDate) return;

    // @ts-ignore
    const parsedReportLastSyncDate = new Date(reportLastSyncDate?.split('.')?.reverse());

    return {
      ...getDateShortcuts(parsedReportLastSyncDate),
      all: {
        text: 'Все',
        period: {
          start: new Date(new Date().setTime(1639699202000)),
          end: new Date(),
        },
      },
    };
  }, [reportLastSyncDate]);

  const defaultDates = useMemo(() => {
    if (!reportLastSyncDate) return;

    // @ts-ignore
    const parsedReportLastSyncDate = new Date(reportLastSyncDate?.split('.')?.reverse());

    return {
      dateFrom: toIsoDate(subtractDaysFromDate(parsedReportLastSyncDate, 31)),
      dateTo: toIsoDate(parsedReportLastSyncDate),
    };
  }, [reportLastSyncDate]);

  // let defaultDateFrom = defaultDates ? defaultDates.dateFrom : null;
  // let defaultDateTo = defaultDates ? defaultDates.dateTo : null;

  return [shortcuts, null, null];
}

export default useCustomDateShortcuts;
